
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinpune() {



  const cardData =
  {
    keyword: 'Innova Cabs on Rent in Pune',
    heading: 'AB Ghule Cabs: Innova Cabs on Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers reliable, comfortable, and luxurious Innova cabs on rent in Pune, providing an exceptional travel experience. Whether you are planning a family trip, corporate outing, or a long-distance journey, our fleet of well-maintained Innova cabs ensures a smooth, safe, and stylish ride. With our experienced drivers, affordable rates, and easy booking process, AB Ghule Cabs is your trusted partner for all your travel needs.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Innova Cabs on Rent in Pune',

    "topPlaces": [
  {
    title: "Spacious and Comfortable Interiors",
    description: "The Innova is known for its spacious interior, offering ample legroom, comfortable seats, and a relaxing environment for passengers. Perfect for family outings, group trips, and long-distance travel."
  },
  {
    title: "Affordable and Transparent Pricing",
    description: "We offer competitive rental rates for Innova cabs with no hidden charges. Our transparent pricing ensures that you know the cost upfront, with no surprises during or after your trip."
  },
  {
    title: "Well-Maintained and Clean Vehicles",
    description: "All our Innova cabs are regularly serviced and thoroughly cleaned to ensure a safe and hygienic travel experience. We prioritize cleanliness and safety to give you a pleasant ride."
  },
  {
    title: "Experienced and Professional Drivers",
    description: "Our experienced drivers are well-versed with the best routes in Pune and surrounding areas. They are trained to ensure safe, comfortable, and timely travel while providing excellent customer service throughout your journey."
  },
  {
    title: "Ideal for Family and Group Travel",
    description: "The Innova is perfect for both small and large groups. With its spacious seating and ample boot space, it comfortably accommodates up to 7 passengers, making it ideal for family vacations, business trips, and group tours."
  },
  {
    title: "Flexible Rental Packages",
    description: "We offer flexible rental packages for daily, weekly, and long-term rentals. Whether you need a cab for a day trip, airport transfer, or a week-long journey, we provide packages tailored to your needs."
  },
  {
    title: "24/7 Availability",
    description: "AB Ghule Cabs offers round-the-clock availability, whether you need an early morning ride, late-night drop, or a last-minute booking. Our service is available 24/7 for your convenience."
  },
  {
    title: "Luxury and Comfort",
    description: "The Innova is a luxury vehicle that combines comfort and style. With plush seating, modern amenities, and smooth driving performance, it provides an elevated travel experience."
  },
  {
    title: "Reliable and Safe Travel",
    description: "Your safety is our priority. The Innova comes equipped with safety features such as airbags, ABS brakes, and a sturdy build. Our drivers ensure that you reach your destination safely while following all traffic regulations."
  },
  {
    title: "Easy Booking Process",
    description: "Booking an Innova cab with AB Ghule Cabs is simple and convenient. You can book your vehicle online or by phone, and our team will assist you with the booking process, ensuring that your travel plans are confirmed without any hassle."
  }
],


services: [
    {
      "name": "Innova Taxi Near Me in Pune",
      description: "Looking for an Innova taxi near you in Pune? AB Ghule Cabs offers a reliable and comfortable Innova taxi service for local and outstation travel. Our vehicles are well-maintained and driven by professional chauffeurs to ensure a smooth and safe journey."
    },
    {
      "name": "Innova Crysta Taxi in Pimpri Chinchwad",
      description: "AB Ghule Cabs offers Innova Crysta taxi services in Pimpri Chinchwad. Whether you’re traveling for business or leisure, our premium vehicles provide the best comfort and luxury for your local and outstation trips."
    },
    {
      "name": "Innova Cab Rental for Local and Outstations",
      description: "Rent an Innova cab for both local and outstation travel in Pune with AB Ghule Cabs. Our flexible rental options cater to your needs, ensuring you have a comfortable and reliable ride to any destination."
    },
    {
      "name": "Innova on Rent for Outstation",
      description: "Looking to rent an Innova for your outstation trip from Pune? AB Ghule Cabs offers reliable Innova rentals with experienced drivers for your comfort and convenience, ensuring you reach your destination in style and safety."
    },
    {
      "name": "Innova Outstation Rental",
      description: "Rent an Innova for your outstation journey with AB Ghule Cabs. We provide competitive rental rates for both long-distance and short trips, with well-maintained vehicles and skilled drivers to ensure a pleasant experience."
    },
    {
      "name": "8 Seater Innova on Rent in Pune",
      description: "For larger groups, AB Ghule Cabs offers 8-seater Innova rentals in Pune. Whether you’re traveling for a family vacation or a corporate outing, our 8-seater Innova ensures ample space and comfort for all passengers."
    },
    {
      "name": "Hire Innova for Outstation",
      description: "Hire an Innova for your outstation trip with AB Ghule Cabs. Our vehicles are ideal for both short and long-distance travel, providing you with a comfortable and stress-free journey."
    },
    {
      "name": "Innova 7 Seater Taxi in Pune",
      description: "AB Ghule Cabs offers 7-seater Innova taxis in Pune, perfect for small groups or families. Rent our spacious and luxurious vehicles for local travel or outstation trips, and enjoy a smooth and relaxing ride."
    },
    {
      "name": "Innova Cab for Rent",
      description: "Rent an Innova cab for your next trip with AB Ghule Cabs. Whether you're looking for a local ride or planning a journey to a distant destination, our well-maintained cabs offer comfort and style for all your travel needs."
    },
    {
      "name": "Innova Cabs Near Me Viman Nagar",
      description: "AB Ghule Cabs provides Innova cabs near Viman Nagar for your convenience. Whether you need a ride for a local meeting or an outstation trip, our vehicles are just a call away for a comfortable and timely service."
    },
    {
      "name": "Innova for Rent Outstation in Kharadi",
      description: "Rent an Innova for your outstation journey from Kharadi with AB Ghule Cabs. Our vehicles are ideal for both personal and corporate trips, providing a comfortable and smooth ride to your destination."
    },
    {
      "name": "Innova Hire for Outstation",
      description: "Hire an Innova for your outstation journey with AB Ghule Cabs. We offer competitive pricing and excellent customer service, ensuring a comfortable ride for you and your family or group."
    },
    {
      "name": "Innova Outstation Cab from Pune",
      description: "Book an Innova outstation cab from Pune with AB Ghule Cabs. Our fleet of well-maintained vehicles, driven by experienced drivers, ensures a safe and enjoyable journey to any outstation destination."
    },
    {
      "name": "Innova Rental for Outstation in Pimpri Chinchwad",
      description: "If you’re in Pimpri Chinchwad and need an Innova rental for an outstation trip, AB Ghule Cabs provides reliable service with competitive pricing. Our vehicles offer comfort and luxury for a seamless journey."
    },
    {
      "name": "Pune to Mahabaleshwar Innova Cab",
      description: "Travel from Pune to Mahabaleshwar in comfort with an Innova cab from AB Ghule Cabs. Our vehicles are spacious and well-maintained, providing a relaxing ride to this scenic hill station."
    },
    {
      "name": "Pune to Shirdi Innova Cab",
      description: "Book an Innova cab for your trip from Pune to Shirdi with AB Ghule Cabs. Whether you’re visiting the Sai Baba Temple or traveling with a group, our vehicles offer comfort, safety, and reliability."
    },
    {
      "name": "Pune to Shirdi Innova Cab Booking",
      description: "Easily book your Pune to Shirdi Innova cab with AB Ghule Cabs. We offer quick online booking and a fleet of well-maintained vehicles to ensure a comfortable and timely journey."
    },
    {
      "name": "Pune Airport to Shirdi Car Rental",
      description: "AB Ghule Cabs offers car rental services from Pune Airport to Shirdi. Choose our Innova cabs for a comfortable, stress-free ride directly from the airport to the Sai Baba Temple or other destinations."
    },
    {
      "name": "Pune to Shani Shingnapur Innova Cab",
      description: "For your trip from Pune to Shani Shingnapur, rent an Innova cab from AB Ghule Cabs. Our professional drivers will ensure you reach the temple safely and comfortably, making your religious journey stress-free."
    },
    {
      "name": "Pune to Goa Innova Cab",
      description: "Planning a trip from Pune to Goa? Rent an Innova cab from AB Ghule Cabs for a comfortable and luxurious ride to the beaches and vibrant culture of Goa. Our well-maintained vehicles and professional drivers ensure a smooth journey."
    },
    {
      "name": "Pune to Goa Innova Cab Booking",
      description: "Easily book your Pune to Goa Innova cab with AB Ghule Cabs. We provide reliable service and competitive rates for your trip to Goa, ensuring a pleasant and comfortable travel experience."
    },
    {
      "name": "Pune to Lonavala Innova Cab",
      description: "Book an Innova cab for your trip from Pune to Lonavala with AB Ghule Cabs. Whether you’re visiting for a weekend getaway or a day trip, our cabs ensure a comfortable ride to this popular hill station."
    },
    {
      "name": "Pune to Bhimashankar Innova Cabs",
      description: "Rent an Innova cab for your trip to Bhimashankar from Pune. AB Ghule Cabs offers a comfortable and reliable ride to this spiritual destination, with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      description: "Travel from Pune to Mumbai in luxury with an Innova cab from AB Ghule Cabs. Whether for business or leisure, our vehicles ensure a smooth and comfortable ride to your destination."
    },
    {
      "name": "Innova Car Hire for Corporate Events in Pune",
      description: "AB Ghule Cabs offers Innova car hire for corporate events in Pune. Whether for business meetings, corporate tours, or airport transfers, our vehicles provide a professional and comfortable experience for your team."
    },
    {
      "name": "Innova Cabs on Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Innova Cabs on Rent in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Innova Taxi Near Me in Pune", "- Innova Crysta Taxi in Pimpri Chinchwad"],
    ["Innova Cab Rental for Local and Outstations", "- Innova on Rent for Outstation"],
    ["Innova Outstation Rental", "- 8 Seater Innova on Rent in Pune"],
    ["Hire Innova for Outstation", "- Innova 7 Seater Taxi in Pune"],
    ["Innova Cab for Rent", "- Innova Cabs Near Me Viman Nagar"],
    ["Innova for Rent Outstation in Kharadi", "- Innova Hire for Outstation"],
    ["Innova Outstation Cab from Pune", "- Innova Rental for Outstation in Pimpri Chinchwad"],
    ["Pune to Mahabaleshwar", "- Pune to Shirdi Innova Cab"],
    ["Pune to Shirdi Innova Cab Booking", "- Pune Airport to Shirdi Car Rental"],
    ["Pune to Shani Shingnapur Innova Cab", "- Pune to Goa Innova Cab"],
    ["Pune to Goa Innova Cab Booking", "- Pune to Goa Innova Cab Booking"],
    ["Pune to Lonavala Innova Cab", "- Pune to Bhimashankar Innova Cabs"],
    ["Pune to Mumbai Innova Cab", "- Innova Car Hire for Corporate Events in Pune"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Comfort and Luxury Travel",
      WhyChoosedescription: "The Toyota Innova is renowned for its comfortable and spacious interiors. Whether you're planning a family trip, a business journey, or a group outing, the Innova offers a premium experience with plush seating and smooth driving."
    },
    {
      WhyChooseheading: "Spacious and Versatile",
      WhyChoosedescription: "Our Innova cabs can comfortably accommodate 7-8 passengers, making it ideal for family vacations, group tours, corporate travel, and more. The ample space and large luggage capacity ensure a convenient and stress-free journey."
    },
    {
      WhyChooseheading: "Professional and Experienced Drivers",
      WhyChoosedescription: "We prioritize your safety and comfort with our experienced, well-trained, and background-checked drivers. They are familiar with the best routes and ensure you travel safely and efficiently to your destination."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "All our Innova cabs undergo regular maintenance and are thoroughly cleaned and sanitized before every ride. Our fleet is kept in excellent condition to ensure a smooth and comfortable ride for every passenger."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive rates for Innova rentals with no hidden charges. Whether you need the car for a few hours or a few days, our pricing structure is clear and designed to suit different budgets."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "We provide flexible rental packages to suit all types of travel needs, whether it’s for a day trip, weekend getaway, or outstation travel. Our services are customizable to fit your specific requirements."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you need an Innova cab in the early hours or late at night, we are available around the clock to cater to your travel needs. Our customer service team is always ready to assist you with bookings and queries."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking an Innova cab is quick and easy. You can make a reservation online through our website, mobile app, or call our customer service team for immediate assistance."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book an Innova cab in Pune?',
      answer: 'You can book an Innova cab via our website, mobile app, or by calling our customer service team. We offer a fast and user-friendly booking process.',
    },
    {
      id: 'FAQ2',
      question: 'How many passengers can an Innova cab accommodate?',
      answer: 'The Innova cab can comfortably accommodate up to 7-8 passengers, making it an excellent choice for families, groups, or corporate travel.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Innova cab air-conditioned?',
      answer: 'Yes, all our Innova cabs are fully air-conditioned to ensure a comfortable ride in all weather conditions.',
    },
    {
      id: 'FAQ4',
      question: 'What is the cost of renting an Innova cab in Pune?',
      answer: 'The cost of renting an Innova cab depends on the rental duration, distance, and additional services requested. We provide competitive pricing and clear, upfront costs with no hidden fees.',
    },
    {
      id: 'FAQ5',
      question: 'Are your drivers experienced and professional?',
      answer: 'Yes, all our drivers are highly trained, experienced, and background-checked to ensure a safe, comfortable, and professional travel experience.',
    },
    {
      id: 'FAQ6',
      question: 'Can I rent an Innova cab for outstation travel?',
      answer: 'Yes, the Innova is ideal for long-distance or outstation travel. We offer flexible packages for trips to nearby cities and tourist destinations.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for my Innova cab rental?',
      answer: 'You can pay via cash, credit/debit card, or online payment through our mobile app. We offer multiple payment methods for your convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours depending on your travel requirements. Any extra charges will be clearly communicated before confirming your booking.',
    },
    {
      id: 'FAQ9',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. You can also contact our customer service team for assistance with changes.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs stand out from other rental services?',
      answer: 'AB Ghule Cabs is known for our focus on customer satisfaction, competitive pricing, well-maintained fleet, and professional drivers. We offer a reliable and personalized experience for all your travel needs in Pune.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Ajay Joshi',
      feedback: 'We rented an Innova for a weekend trip to nearby attractions, and the experience was amazing. The vehicle was clean, comfortable, and well-maintained, and the driver was courteous and knowledgeable about the best routes. It was the perfect choice for our family trip, and we’ll definitely rent from AB Ghule Cabs again!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Rina Deshmukh',
      feedback: 'I booked an Innova cab for a business trip with AB Ghule Cabs, and the service was exceptional. The driver was professional, and the vehicle was spacious and comfortable, which made the long journey smooth and relaxing. I highly recommend their services for both corporate and leisure travel.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Innova Cabs on Rent in Pune | Book Innova Crysta for Local & Outstation Trips</title>
  <meta name="description" content="Innova Cabs on rent in Pune. Offering 7-seater Innova Crysta for outstation and local trips. Book online or call +91 8624029699 for trips to Mahabaleshwar, Shirdi, Goa, and more." />
  <meta name="keywords" content="Innova taxi near me in Pune, Innova Crysta Taxi in pimpri chinchwad, Innova cab Rental for Local and Outstations, Innova on rent for outstation, Innova Outstation Rental, 8 Seater innova on rent in pune, Hire innova for outstation, Innova 7 Seater Taxi in Pune, Innova Cab for Rent, Innova cabs near me Viman nagar, Innova for rent outstation in Kharadi, Innova hire for outstation, Innova outstation cab from pune, Innova rental for outstation in pimpri chinchwad, pune to mahabaleshwar, Pune to Shirdi Innova Cab, Pune To Shirdi Innova Cab Booking, Pune Airport to Shirdi Car Rental, pune to shani shingnapur innova cab, Pune to Goa Innova Cab, Pune To Goa Innova Cab Booking, Pune to goa innova cab booking, Pune to Lonavala Innova Cab, pune to bhimashankar innova Cabs, pune to mumbai innova cab, innova car hire for corporate events in pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Innova Cabs on Rent in Pune | Book Innova Crysta for Local & Outstation Trips" />
  <meta property="og:description" content="Innova Cabs on rent in Pune. Offering 7-seater Innova Crysta for outstation and local trips. Book online or call +91 8624029699 for trips to Mahabaleshwar, Shirdi, Goa, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/innova-cabs-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/innova-cabs-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Innova Cabs on Rent in Pune",
        description: "Innova Cabs on rent in Pune. Offering 7-seater Innova Crysta for outstation and local trips. Book online or call +91 8624029699 for trips to Mahabaleshwar, Shirdi, Goa, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/innova-cabs-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/innova-cabs-rent.jpg",
        "image": "https://abghulecabs.com/images/innova-cabs-rent.jpg",
        "priceRange": "₹2000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/innova-cabs-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Amit P"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "We hired an Innova Crysta for our trip to Goa. The car was clean, comfortable, and well-maintained. Excellent service!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi K"
            },
            "datePublished": "2024-10-25",
            "reviewBody": "Booked an Innova Crysta for a trip to Mahabaleshwar. Great experience with AB Ghule Cabs. Highly recommended!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Innova Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/innova-cabs-on-rent-in-pune"
        },
        "keywords": "Innova taxi near me in Pune, Innova Crysta Taxi in pimpri chinchwad, Innova cab Rental for Local and Outstations, Innova on rent for outstation, Innova Outstation Rental, 8 Seater innova on rent in pune, Hire innova for outstation, Innova 7 Seater Taxi in Pune, Innova Cab for Rent, Innova cabs near me Viman nagar, Innova for rent outstation in Kharadi, Innova hire for outstation, Innova outstation cab from pune, Innova rental for outstation in pimpri chinchwad, pune to mahabaleshwar, Pune to Shirdi Innova Cab, Pune To Shirdi Innova Cab Booking, Pune Airport to Shirdi Car Rental, pune to shani shingnapur innova cab, Pune to Goa Innova Cab, Pune To Goa Innova Cab Booking, Pune to goa innova cab booking, Pune to Lonavala Innova Cab, pune to bhimashankar innova Cabs, pune to mumbai innova cab, innova car hire for corporate events in pune"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/41.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Innovacrystaonrentinpune;